@if (tenant) {
<app-card
  [background]="!this.tenantConfigurationService.isReadMode()"
  [partialFullHeight]="true"
  size="large"
  [spacingBottom]="Spacing.NONE"
  data-test-id="general-tenant-card"
>
  <section>
    <header class="tenant-general-header">
      <h1 class="section-title">General</h1>
      <app-form-action-button
        [type]="this.tenantConfigurationService.isReadMode() ? 'edit' : 'save'"
        [disabled]="!isConfigurationsValid()"
        [buttonType]="
          this.tenantConfigurationService.isReadMode()
            ? NativeButtonType.BUTTON
            : NativeButtonType.SUBMIT
        "
        (handleClick)="handleEdit()"
        data-test-id="tenant-configuration-save-edit-button"
      >
      </app-form-action-button>
    </header>
    <app-tenant-general-form
      [readMode]="this.tenantConfigurationService.isReadMode()"
      [(name)]="name"
      [(description)]="description"
      [(slugs)]="slugs"
      [(emails)]="emails"
      [(provisioningType)]="provisioningType"
      (formSubmit)="onSubmit()"
      [tenant]="tenant"
      data-test-id="general-tenant-form"
    ></app-tenant-general-form>
  </section>
</app-card>
} @else {
<app-spinner data-test-id="general-spinner"></app-spinner>
}
<app-tenant-dialog
  [(isOpen)]="dialogOpen"
  (handleClose)="closeDialog()"
  (save)="saveTenant($event)"
  data-test-id="general-tenant-dialog"
></app-tenant-dialog>
